import { Injectable } from '@angular/core';
import { CfgService } from '../../cfg/cfg.service';
import { HttpBackend } from '@angular/common/http';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class LauncherCfg {
  resourceId: number;
}

@Injectable({
  providedIn: 'root'
})
export class LauncherCfgService extends CfgService<LauncherCfg> {
  json: any = {
    resourceId: 189
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/launcher.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
